import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AdresseModels } from 'src/app/models/adresse-models';

@Component({
  selector: 'app-ort-auswahl',
  templateUrl: './ort-auswahl.component.html',
  styleUrls: ['./ort-auswahl.component.scss']
})
export class OrtAuswahlComponent implements OnInit {

  private orte: AdresseModels.Ort[] = [];

    // Spalten im Orte-Grid
    dataSourceCities: MatTableDataSource<AdresseModels.Ort>;
    displayedCityColumns: string[] = ['country', 'city', 'canton'];
    selectedCity?: AdresseModels.Ort;

  constructor(@Inject(MAT_DIALOG_DATA) public data: AdresseModels.Ort[],
              public dialogRef: MatDialogRef<OrtAuswahlComponent>) { 
    this.orte = data;
    this.dataSourceCities = new MatTableDataSource<AdresseModels.Ort>(this.orte);
  }

  ngOnInit(): void {
  }

  highlight(row: any) {
    this.selectedCity = row;
    this.dialogRef.close(this.selectedCity);
  }

}
